<template lang="pug">
    .container(ref='container')
        .animated-scroll(
            ref='animatedScroll'
            )
            svg(width='100%' height='100%' viewBox='0 0 1280 720' preserveAspectRatio='xMidYMid meet')
                g(ref='gasoline')
                    path(d='M637.838 43.6552L636.783 42.6001L530.278 42.6001L529.223 43.6552L529.223 150.44L529.999 151.215L637.063 151.215L637.838 150.44L637.838 43.6552Z' fill='black')
                    path(fill-rule='evenodd' clip-rule='evenodd' d='M857.924 245.151L825.836 298.373L789.806 276.681L823.57 224.297L857.924 245.151Z' fill='black')
                    path(fill-rule='evenodd' clip-rule='evenodd' d='M865.65 242.793L827.914 305.324L853.578 322.02L891.842 258.62L865.65 242.793Z' fill='black')
                    path(d='M827.232 207.695L880.298 179.765L917.538 128.685L918.189 -71.3223L889.174 -104L411.298 -104L375.051 -71.3224L375.051 262.064L411.298 294.432L770.535 294.432L827.232 207.695ZM885.822 109.01L862.485 142.743L821.367 163.783L821.367 7.50129L885.853 -31.9105L885.853 109.01L885.822 109.01ZM456.264 235.159L445.279 224.173L513.706 155.746L513.706 38.317L445.279 -30.1106L456.264 -41.0963L524.413 27.052L642.679 27.052L710.827 -41.0652L721.813 -30.0796L653.385 38.348L653.385 155.746L721.813 224.173L710.827 235.159L642.4 166.731L524.692 166.731L456.264 235.159Z' fill='black')
                    g(ref='drop' v-for='item, index in 6' :key='index')
                        path(d='M894.433 299.445C904.565 325.612 919.863 340.178 919.863 354.346C919.863 368.514 908.479 380 894.433 380C880.387 380 869.001 368.514 869.001 354.346C869.001 340.178 884.302 325.612 894.433 299.445ZM902.034 329.866C903.675 333.675 906.058 338.691 907.901 343.817C908.814 346.374 909.544 348.975 909.813 351.365C909.855 351.953 909.92 352.563 909.901 353.067C909.898 353.332 909.914 353.564 909.881 353.889L909.848 354.344L909.833 354.567L909.824 354.68L909.82 354.735C909.815 354.806 909.824 354.656 909.822 354.673L909.82 354.686L909.815 354.713C909.714 355.243 909.616 355.76 909.52 356.258C909.474 356.505 909.43 356.75 909.384 356.991C909.318 357.225 909.233 357.449 909.16 357.672C908.865 358.558 908.624 359.386 908.271 359.983C907.942 360.624 907.769 361.141 907.375 361.676C906.716 362.688 906.339 363.267 906.339 363.267C905.644 364.332 905.938 365.766 906.994 366.468C908.052 367.169 909.474 366.873 910.168 365.808C910.212 365.739 910.251 365.668 910.288 365.598C910.288 365.598 910.604 364.983 911.156 363.907C911.443 363.434 911.743 362.553 912.082 361.651C912.475 360.73 912.67 359.705 912.913 358.587C912.972 358.308 913.042 358.025 913.09 357.734C913.116 357.437 913.143 357.137 913.169 356.832C913.217 356.222 913.27 355.592 913.32 354.947L913.327 354.815L913.325 354.757L913.32 354.647L913.311 354.421L913.298 353.966C913.298 353.683 913.254 353.299 913.219 352.943C913.165 352.198 913.02 351.547 912.895 350.853C912.295 348.124 911.219 345.466 910.008 342.931C907.57 337.869 904.692 333.16 902.67 329.547C900.622 325.943 899.257 323.542 899.257 323.542C899.257 323.542 900.37 326.067 902.034 329.866Z' fill='black')
            .mask(ref='mask')

</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/animatedScreen';

//import * as basicScroll from 'basicscroll';

export default {
    props: {
        rows: {
            type: String
        },
        modifierClass: String,
        settings: Object,
        isActive: Boolean
    },
    data() {
        return {
            innerBlockPosition: 'top',
            isControlScroll: true
        };
    },
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.scrollHandler();
            this.createScroll('top-bottom', 'bottom-top');
        },
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});
            this.timeline
                .set(this.$refs.mask, {scaleY: 0}, 0)
                .set(this.$refs.gasoline, {x: -1000}, 0)
                .set(this.$refs.drop, {scale: 0}, 0)
                .fromTo(this.$refs.gasoline, {x: -1000}, {duration: 0.5, x: '0'}, 0)
                .fromTo(this.$refs.mask, {scaleY: 0}, {duration: 2, scaleY: 1, ease: 'none', transformOrigin: '50% 100%'}, 1)
                .fromTo(this.$refs.drop, {scale: 0}, {duration: 0.2, scale: 1, stagger: {amount: 3}, ease: 'power3.in'}, 1)
                .fromTo(this.$refs.drop, {scale: 1, y: '0'}, {duration: 0.4, scale: 2, y: '200vh', stagger: {amount: 3}, ease: 'power3.in'}, 1.2);
            this.timeline.progress(0.0001);
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';

.container {
    height: 200vh;
    position: relative;
    overflow: hidden;
}

.animated-scroll {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    height: auto;
    width: 100%;
    height: 100vh;
    background-color: var(--theme);
}

.mask {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: var(--color-black);
}
</style>
